<div class="trial" #container>
    <div class="card" [ngClass]="{'flipped' : flipped || revealed, 'no-animations' : !animate}"
        [style.fontSize]="container.offsetWidth * 0.1 + 'px'" card-reveal [disabled]="!reveal"
        (change)="onChange($event)">
        <div class="card-back">
            <span class="revealed"><span class="text" [ghs-label]="'game.cards.confirmReveal'"></span></span>
        </div>
        <div class="card-front">
            <ng-container *ngIf="!!trialCard">
                <div class="title" [ghs-label]="'data.trials.' + trialCard.edition + '.' +  trialCard.cardId">
                </div>
                <div class="automation">
                    <img *ngIf="trialCard.automation && settingsManager.settings.fhChallengesApply"
                        [ghs-tooltip]="'campaign.trials.automation'" class="ghs-svg"
                        src="./assets/images/automation.svg">
                </div>
                <div class="text">
                    <p class="placeholder margin-breaks"
                        [ghs-label]="'data.trials.' + trialCard.edition + '.' +  trialCard.cardId + '.text'"></p>
                </div>
                <div class="card-id">
                    <span *ngIf="trialCard.cardId < 1000">0</span>{{settingsManager.settings.fhSecondEdition ?
                    gameManager.trialsManager.cardIdSecondPrinting(trialCard.cardId) : trialCard.cardId}}
                </div>
            </ng-container>
        </div>
    </div>
</div>